import { render, staticRenderFns } from "./manage-anamnese.html?vue&type=template&id=3a6fb30e&scoped=true&external"
import script from "./manage-anamnese.js?vue&type=script&lang=js&external"
export * from "./manage-anamnese.js?vue&type=script&lang=js&external"
import style0 from "./manage-anamnese.scss?vue&type=style&index=0&id=3a6fb30e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6fb30e",
  null
  
)

export default component.exports